import type { FC } from 'react';

import type { IconProps } from './BaseIcon';
import { BaseIcon } from './BaseIcon';

export const NotionIcon: FC<IconProps> = ({
  preserveColor = false,
  ...props
}) => (
  <BaseIcon {...props} customFill={preserveColor}>
    <g clipPath="url(#notion-a)">
      <path
        fill="#fff"
        d="m5.444 5.035 13.28-.98c1.631-.14 2.05-.046 3.076.7l4.24 2.986c.698.513.931.653.931 1.212v16.379c0 1.026-.373 1.633-1.677 1.726l-15.422.934c-.98.046-1.445-.094-1.958-.747l-3.122-4.06C4.232 22.44 4 21.88 4 21.226V6.668c0-.84.373-1.539 1.444-1.632Z"
      />
      <path
        fill="#000"
        d="m18.724 4.055-13.28.98C4.373 5.128 4 5.828 4 6.667v14.559c0 .653.232 1.212.792 1.96l3.122 4.059c.513.653.979.793 1.958.747l15.422-.934c1.304-.093 1.677-.7 1.677-1.726V8.954c0-.53-.21-.684-.826-1.136L21.8 4.754c-1.025-.745-1.445-.84-3.076-.7Zm-8.503 4.63c-1.26.085-1.545.104-2.26-.477L6.142 6.762c-.184-.187-.091-.421.374-.468l12.767-.932c1.072-.094 1.63.28 2.05.606l2.189 1.586c.093.048.326.327.046.327l-13.184.794-.163.01ZM8.753 25.193V11.288c0-.607.186-.887.744-.934l15.143-.887c.514-.046.746.28.746.887v13.81c0 .608-.094 1.122-.932 1.168l-14.49.84c-.839.046-1.211-.233-1.211-.98Zm14.304-13.158c.093.42 0 .84-.42.888l-.699.138v10.266c-.606.326-1.164.512-1.631.512-.746 0-.932-.233-1.49-.932l-4.568-7.186v6.952l1.445.327s0 .84-1.165.84l-3.214.187c-.094-.188 0-.654.326-.747l.839-.233v-9.192l-1.165-.094c-.093-.42.14-1.026.792-1.073l3.448-.232 4.752 7.278v-6.44l-1.211-.138c-.094-.515.28-.888.745-.934l3.216-.187Z"
      />
    </g>
    <defs>
      <clipPath id="notion-a">
        <path fill="#fff" d="M4 4h24v24H4z" />
      </clipPath>
    </defs>
  </BaseIcon>
);
